import { UniformLogo, flattenLogoProps } from "src/uniform/contenttypes/logo";

import { Integration, IntegrationRefresh } from "@/libraries/design/patterns";
import {
    IntegrationBackgroundType,
    IntegrationBackgroundColor
} from "@/libraries/design/patterns/integration/src/integration";
import { RichTextComponent } from "@/libraries/design/utils";
import {
    EnrollmentType,
    useExperiment
} from "@/utils/experiment/use-experiment";
import { wacRefreshQ4Fy26Experiment } from "@/utils/experiment/wacRefreshExperiment";

export interface UniformIntegrationProps {
    eyebrow?: string;
    title?: string;
    titleAs?: "h2" | "h3";
    titleAppearsAs?: "h2" | "h3";
    body?: string;
    richText?: string;
    linkLabel?: string;
    linkHref?: string;
    logos: UniformLogo[];
    clickableLogos?: boolean;
    background?: IntegrationBackgroundType;
    backgroundColor?: IntegrationBackgroundColor;
    flipLayout?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const UniformIntegration = (props: any) => {
    const {
        eyebrow,
        title,
        titleAs,
        titleAppearsAs,
        body,
        richText,
        linkLabel,
        linkHref,
        logos,
        clickableLogos,
        background,
        backgroundColor,
        flipLayout
    } = flattenLogoProps(props);
    const checkWacRefresh = useExperiment(wacRefreshQ4Fy26Experiment);
    const isWacRefresh =
        checkWacRefresh.type === EnrollmentType?.ENROLLED &&
        checkWacRefresh.value;

    if (isWacRefresh) {
        return (
            <IntegrationRefresh
                title={title}
                titleAs={titleAs}
                titleAppearsAs={titleAppearsAs}
                body={richText ? <RichTextComponent text={richText} /> : body}
                linkLabel={linkLabel}
                linkHref={linkHref}
                linkDataEventProps={{
                    "data-product-key": "uniform",
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": "integrationsSection"
                }}
                logoLinkDataEventProps={{
                    "data-product-key": "uniform",
                    "data-event": "clicked",
                    "data-event-component": "linkLogo",
                    "data-event-container": "integrationsSection"
                }}
                clickableLogos={clickableLogos}
                logos={logos}
            />
        );
    } else {
        return (
            <Integration
                eyebrow={eyebrow}
                title={title}
                titleAs={titleAs}
                titleAppearsAs={titleAppearsAs}
                body={richText ? <RichTextComponent text={richText} /> : body}
                linkLabel={linkLabel}
                linkHref={linkHref}
                linkDataEventProps={{
                    "data-product-key": "uniform",
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": "integrationsSection"
                }}
                logoLinkDataEventProps={{
                    "data-product-key": "uniform",
                    "data-event": "clicked",
                    "data-event-component": "linkLogo",
                    "data-event-container": "integrationsSection"
                }}
                logos={logos}
                background={background}
                backgroundColor={backgroundColor}
                flipLayout={flipLayout}
            />
        );
    }
};

export default UniformIntegration;
